import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=410f006a&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=410f006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f006a",
  null
  
)

export default component.exports